import React from "react";
import { ExpandedDescriptionTextSection } from "~/ProductDetails/ProductDetailPageResult";
import Section from "./Section";
interface Props {
  section: ExpandedDescriptionTextSection;
}
const ContentTextImageLeft = ({
  section
}: Props) => <>
    {section && <div className="detail-section textimage-left-template" data-testid="content-image-text-left">
        <div className="flex-container items-center">
          <Section section={section} videoClassNames="order-1 px-8 sm:pr-0 sm:pb-0 pb-4" />
        </div>
      </div>}
  </>;
export default ContentTextImageLeft;